export const WEEKDAY_LABELS = ["日", "一", "二", "三", "四", "五", "六"];

export function formatDate(iso: string): string {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}

export function formatShortDate(iso: string): { day: string; month: string; year: string } {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return { day: "--", month: "--", year: "" };
  }
  return {
    day: String(date.getDate()).padStart(2, "0"),
    month: `${date.getMonth() + 1}月`,
    year: String(date.getFullYear()),
  };
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}

export function formatDuration(minutes: number): string {
  return `${minutes} 分钟`;
}

export function durationBucketLabel(value: string): string {
  if (value === "short") return "0-5 分钟";
  if (value === "medium") return "5-15 分钟";
  if (value === "long") return "15 分钟以上";
  return "全部时长";
}